// Public surface of the Teach Phoebe slice: the page the route mounts, the
// training-branded primitives the app chrome renders outside this feature
// (the sidebar flower, the chat badge), the chat's Review-my-runs card, and
// the run actions the home feed's training card dispatches. Everything else
// stays internal.
export { useTrainingRunActions } from '@apps/web/features/teach_phoebe/model/use_training_run_actions';
export { ReviewMyRunsCard } from '@apps/web/features/teach_phoebe/ui/review_my_runs_card';
export { TeachPhoebePage } from '@apps/web/features/teach_phoebe/ui/teach_phoebe_page';
export { TrainingFlower } from '@apps/web/features/teach_phoebe/ui/training_flower';
export { TrainingModeBadge } from '@apps/web/features/teach_phoebe/ui/training_mode_badge';
